import { motion } from 'framer-motion';

export default function Method() {
  const steps = [
    {
      number: '01',
      icon: 'ri-survey-line',
      title: 'Análise do Terreno',
      description: 'Estudo completo do lote, topografia, insolação, ventilação e entorno em Ilhabela.'
    },
    {
      number: '02',
      icon: 'ri-lightbulb-line',
      title: 'Conceito Arquitetônico',
      description: 'Criação do conceito do projeto, definindo linguagem e organização dos espaços.'
    },
    {
      number: '03',
      icon: 'ri-draft-line',
      title: 'Desenvolvimento',
      description: 'Elaboração do projeto completo, compatibilizado com soluções técnicas.'
    },
    {
      number: '04',
      icon: 'ri-tools-line',
      title: 'Acompanhamento',
      description: 'Suporte técnico durante a execução para garantir qualidade e prazos.'
    }
  ];

  return (
    <section className="bg-white py-16 sm:py-24">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-20"
        >
          <h2 className="font-playfair text-3xl sm:text-4xl lg:text-5xl text-gray-900 mb-4">Nosso Método</h2>
          <div className="w-16 h-px bg-gray-300 mx-auto"></div>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 relative">
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-px border-t-2 border-dashed border-gray-200"></div>

          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative text-center"
            >
              <div className="text-5xl sm:text-7xl font-playfair font-extralight text-gray-200 mb-4 sm:mb-6">
                {step.number}
              </div>
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 sm:mb-5 relative z-10 bg-white">
                <i className={`${step.icon} text-3xl sm:text-4xl text-gray-900`}></i>
              </div>
              <h3 className="font-inter font-semibold text-base sm:text-lg text-gray-900 mb-3 sm:mb-4">
                {step.title}
              </h3>
              <p className="font-inter text-sm text-gray-700 leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
